export const ROUTES = {
    login: '/',
    products: '/products',
    parameters: '/parameters',
};
